"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EE = void 0;
exports.EE = {
    numericCode: '233',
    alpha2Code: 'EE',
    alpha3Code: 'EST',
    englishName: {
        short: 'Estonia',
        full: 'the Republic of Estonia',
    },
    names: {
        full: {
            en: 'the Republic of Estonia',
            fr: "la République d'Estonie",
            et: 'Eesti',
        },
        short: {
            en: 'Estonia',
            fr: "Estonie (l')",
            et: 'Eesti',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'et',
            languageAlpha3Code: 'est',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
    ],
    subdivisions: {
        'EE-37': {
            numericCode: '233',
            code: 'EE-37',
            category: {
                id: '407',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    et: {
                        singular: 'maakond',
                        plural: '',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                et: 'Harjumaa',
            },
        },
        'EE-296': {
            numericCode: '233',
            code: 'EE-296',
            category: {
                id: '483',
                names: {
                    en: {
                        singular: 'urban municipality',
                        plural: 'urban municipalities',
                    },
                    et: {
                        singular: 'linn',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité urbaine',
                        plural: '',
                    },
                },
            },
            parent: 'EE-37',
            names: {
                et: 'Keila',
            },
        },
        'EE-424': {
            numericCode: '233',
            code: 'EE-424',
            category: {
                id: '483',
                names: {
                    en: {
                        singular: 'urban municipality',
                        plural: 'urban municipalities',
                    },
                    et: {
                        singular: 'linn',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité urbaine',
                        plural: '',
                    },
                },
            },
            parent: 'EE-37',
            names: {
                et: 'Loksa',
            },
        },
        'EE-446': {
            numericCode: '233',
            code: 'EE-446',
            category: {
                id: '483',
                names: {
                    en: {
                        singular: 'urban municipality',
                        plural: 'urban municipalities',
                    },
                    et: {
                        singular: 'linn',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité urbaine',
                        plural: '',
                    },
                },
            },
            parent: 'EE-37',
            names: {
                et: 'Maardu',
            },
        },
        'EE-784': {
            numericCode: '233',
            code: 'EE-784',
            category: {
                id: '483',
                names: {
                    en: {
                        singular: 'urban municipality',
                        plural: 'urban municipalities',
                    },
                    et: {
                        singular: 'linn',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité urbaine',
                        plural: '',
                    },
                },
            },
            parent: 'EE-37',
            names: {
                et: 'Tallinn',
            },
        },
        'EE-141': {
            numericCode: '233',
            code: 'EE-141',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-37',
            names: {
                et: 'Anija',
            },
        },
        'EE-198': {
            numericCode: '233',
            code: 'EE-198',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-37',
            names: {
                et: 'Harku',
            },
        },
        'EE-245': {
            numericCode: '233',
            code: 'EE-245',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-37',
            names: {
                et: 'Jõelähtme',
            },
        },
        'EE-305': {
            numericCode: '233',
            code: 'EE-305',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-37',
            names: {
                et: 'Kiili',
            },
        },
        'EE-338': {
            numericCode: '233',
            code: 'EE-338',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-37',
            names: {
                et: 'Kose',
            },
        },
        'EE-353': {
            numericCode: '233',
            code: 'EE-353',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-37',
            names: {
                et: 'Kuusalu',
            },
        },
        'EE-431': {
            numericCode: '233',
            code: 'EE-431',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-37',
            names: {
                et: 'Lääne-Harju',
            },
        },
        'EE-651': {
            numericCode: '233',
            code: 'EE-651',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-37',
            names: {
                et: 'Raasiku',
            },
        },
        'EE-653': {
            numericCode: '233',
            code: 'EE-653',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-37',
            names: {
                et: 'Rae',
            },
        },
        'EE-719': {
            numericCode: '233',
            code: 'EE-719',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-37',
            names: {
                et: 'Saku',
            },
        },
        'EE-726': {
            numericCode: '233',
            code: 'EE-726',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-37',
            names: {
                et: 'Saue',
            },
        },
        'EE-890': {
            numericCode: '233',
            code: 'EE-890',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-37',
            names: {
                et: 'Viimsi',
            },
        },
        'EE-39': {
            numericCode: '233',
            code: 'EE-39',
            category: {
                id: '407',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    et: {
                        singular: 'maakond',
                        plural: '',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                et: 'Hiiumaa',
            },
        },
        'EE-205': {
            numericCode: '233',
            code: 'EE-205',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-39',
            names: {
                et: 'Hiiumaa',
            },
        },
        'EE-45': {
            numericCode: '233',
            code: 'EE-45',
            category: {
                id: '407',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    et: {
                        singular: 'maakond',
                        plural: '',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                et: 'Ida-Virumaa',
            },
        },
        'EE-321': {
            numericCode: '233',
            code: 'EE-321',
            category: {
                id: '483',
                names: {
                    en: {
                        singular: 'urban municipality',
                        plural: 'urban municipalities',
                    },
                    et: {
                        singular: 'linn',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité urbaine',
                        plural: '',
                    },
                },
            },
            parent: 'EE-45',
            names: {
                et: 'Kohtla-Järve',
            },
        },
        'EE-511': {
            numericCode: '233',
            code: 'EE-511',
            category: {
                id: '483',
                names: {
                    en: {
                        singular: 'urban municipality',
                        plural: 'urban municipalities',
                    },
                    et: {
                        singular: 'linn',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité urbaine',
                        plural: '',
                    },
                },
            },
            parent: 'EE-45',
            names: {
                et: 'Narva',
            },
        },
        'EE-514': {
            numericCode: '233',
            code: 'EE-514',
            category: {
                id: '483',
                names: {
                    en: {
                        singular: 'urban municipality',
                        plural: 'urban municipalities',
                    },
                    et: {
                        singular: 'linn',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité urbaine',
                        plural: '',
                    },
                },
            },
            parent: 'EE-45',
            names: {
                et: 'Narva-Jõesuu',
            },
        },
        'EE-735': {
            numericCode: '233',
            code: 'EE-735',
            category: {
                id: '483',
                names: {
                    en: {
                        singular: 'urban municipality',
                        plural: 'urban municipalities',
                    },
                    et: {
                        singular: 'linn',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité urbaine',
                        plural: '',
                    },
                },
            },
            parent: 'EE-45',
            names: {
                et: 'Sillamäe',
            },
        },
        'EE-130': {
            numericCode: '233',
            code: 'EE-130',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-45',
            names: {
                et: 'Alutaguse',
            },
        },
        'EE-251': {
            numericCode: '233',
            code: 'EE-251',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-45',
            names: {
                et: 'Jõhvi',
            },
        },
        'EE-442': {
            numericCode: '233',
            code: 'EE-442',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-45',
            names: {
                et: 'Lüganuse',
            },
        },
        'EE-803': {
            numericCode: '233',
            code: 'EE-803',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-45',
            names: {
                et: 'Toila',
            },
        },
        'EE-50': {
            numericCode: '233',
            code: 'EE-50',
            category: {
                id: '407',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    et: {
                        singular: 'maakond',
                        plural: '',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                et: 'Jõgevamaa',
            },
        },
        'EE-247': {
            numericCode: '233',
            code: 'EE-247',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-50',
            names: {
                et: 'Jõgeva',
            },
        },
        'EE-486': {
            numericCode: '233',
            code: 'EE-486',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-50',
            names: {
                et: 'Mustvee',
            },
        },
        'EE-618': {
            numericCode: '233',
            code: 'EE-618',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-50',
            names: {
                et: 'Põltsamaa',
            },
        },
        'EE-52': {
            numericCode: '233',
            code: 'EE-52',
            category: {
                id: '407',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    et: {
                        singular: 'maakond',
                        plural: '',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                et: 'Järvamaa',
            },
        },
        'EE-567': {
            numericCode: '233',
            code: 'EE-567',
            category: {
                id: '483',
                names: {
                    en: {
                        singular: 'urban municipality',
                        plural: 'urban municipalities',
                    },
                    et: {
                        singular: 'linn',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité urbaine',
                        plural: '',
                    },
                },
            },
            parent: 'EE-52',
            names: {
                et: 'Paide',
            },
        },
        'EE-255': {
            numericCode: '233',
            code: 'EE-255',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-52',
            names: {
                et: 'Järva',
            },
        },
        'EE-834': {
            numericCode: '233',
            code: 'EE-834',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-52',
            names: {
                et: 'Türi',
            },
        },
        'EE-56': {
            numericCode: '233',
            code: 'EE-56',
            category: {
                id: '407',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    et: {
                        singular: 'maakond',
                        plural: '',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                et: 'Läänemaa',
            },
        },
        'EE-184': {
            numericCode: '233',
            code: 'EE-184',
            category: {
                id: '483',
                names: {
                    en: {
                        singular: 'urban municipality',
                        plural: 'urban municipalities',
                    },
                    et: {
                        singular: 'linn',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité urbaine',
                        plural: '',
                    },
                },
            },
            parent: 'EE-56',
            names: {
                et: 'Haapsalu',
            },
        },
        'EE-441': {
            numericCode: '233',
            code: 'EE-441',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-56',
            names: {
                et: 'Lääne-Nigula',
            },
        },
        'EE-907': {
            numericCode: '233',
            code: 'EE-907',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-56',
            names: {
                et: 'Vormsi',
            },
        },
        'EE-60': {
            numericCode: '233',
            code: 'EE-60',
            category: {
                id: '407',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    et: {
                        singular: 'maakond',
                        plural: '',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                et: 'Lääne-Virumaa',
            },
        },
        'EE-663': {
            numericCode: '233',
            code: 'EE-663',
            category: {
                id: '483',
                names: {
                    en: {
                        singular: 'urban municipality',
                        plural: 'urban municipalities',
                    },
                    et: {
                        singular: 'linn',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité urbaine',
                        plural: '',
                    },
                },
            },
            parent: 'EE-60',
            names: {
                et: 'Rakvere',
            },
        },
        'EE-191': {
            numericCode: '233',
            code: 'EE-191',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-60',
            names: {
                et: 'Haljala',
            },
        },
        'EE-272': {
            numericCode: '233',
            code: 'EE-272',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-60',
            names: {
                et: 'Kadrina',
            },
        },
        'EE-661': {
            numericCode: '233',
            code: 'EE-661',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-60',
            names: {
                et: 'Rakvere',
            },
        },
        'EE-792': {
            numericCode: '233',
            code: 'EE-792',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-60',
            names: {
                et: 'Tapa',
            },
        },
        'EE-901': {
            numericCode: '233',
            code: 'EE-901',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-60',
            names: {
                et: 'Vinni',
            },
        },
        'EE-903': {
            numericCode: '233',
            code: 'EE-903',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-60',
            names: {
                et: 'Viru-Nigula',
            },
        },
        'EE-928': {
            numericCode: '233',
            code: 'EE-928',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-60',
            names: {
                et: 'Väike-Maarja',
            },
        },
        'EE-64': {
            numericCode: '233',
            code: 'EE-64',
            category: {
                id: '407',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    et: {
                        singular: 'maakond',
                        plural: '',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                et: 'Põlvamaa',
            },
        },
        'EE-284': {
            numericCode: '233',
            code: 'EE-284',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-64',
            names: {
                et: 'Kanepi',
            },
        },
        'EE-622': {
            numericCode: '233',
            code: 'EE-622',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-64',
            names: {
                et: 'Põlva',
            },
        },
        'EE-708': {
            numericCode: '233',
            code: 'EE-708',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-64',
            names: {
                et: 'Räpina',
            },
        },
        'EE-68': {
            numericCode: '233',
            code: 'EE-68',
            category: {
                id: '407',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    et: {
                        singular: 'maakond',
                        plural: '',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                et: 'Pärnumaa',
            },
        },
        'EE-624': {
            numericCode: '233',
            code: 'EE-624',
            category: {
                id: '483',
                names: {
                    en: {
                        singular: 'urban municipality',
                        plural: 'urban municipalities',
                    },
                    et: {
                        singular: 'linn',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité urbaine',
                        plural: '',
                    },
                },
            },
            parent: 'EE-68',
            names: {
                et: 'Pärnu',
            },
        },
        'EE-214': {
            numericCode: '233',
            code: 'EE-214',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-68',
            names: {
                et: 'Häädemeeste',
            },
        },
        'EE-303': {
            numericCode: '233',
            code: 'EE-303',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-68',
            names: {
                et: 'Kihnu',
            },
        },
        'EE-430': {
            numericCode: '233',
            code: 'EE-430',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-68',
            names: {
                et: 'Lääneranna',
            },
        },
        'EE-638': {
            numericCode: '233',
            code: 'EE-638',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-68',
            names: {
                et: 'Põhja-Pärnumaa',
            },
        },
        'EE-712': {
            numericCode: '233',
            code: 'EE-712',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-68',
            names: {
                et: 'Saarde',
            },
        },
        'EE-809': {
            numericCode: '233',
            code: 'EE-809',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-68',
            names: {
                et: 'Tori',
            },
        },
        'EE-71': {
            numericCode: '233',
            code: 'EE-71',
            category: {
                id: '407',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    et: {
                        singular: 'maakond',
                        plural: '',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                et: 'Raplamaa',
            },
        },
        'EE-293': {
            numericCode: '233',
            code: 'EE-293',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-71',
            names: {
                et: 'Kehtna',
            },
        },
        'EE-317': {
            numericCode: '233',
            code: 'EE-317',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-71',
            names: {
                et: 'Kohila',
            },
        },
        'EE-503': {
            numericCode: '233',
            code: 'EE-503',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-71',
            names: {
                et: 'Märjamaa',
            },
        },
        'EE-668': {
            numericCode: '233',
            code: 'EE-668',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-71',
            names: {
                et: 'Rapla',
            },
        },
        'EE-74': {
            numericCode: '233',
            code: 'EE-74',
            category: {
                id: '407',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    et: {
                        singular: 'maakond',
                        plural: '',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                et: 'Saaremaa',
            },
        },
        'EE-478': {
            numericCode: '233',
            code: 'EE-478',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-74',
            names: {
                et: 'Muhu',
            },
        },
        'EE-689': {
            numericCode: '233',
            code: 'EE-689',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-74',
            names: {
                et: 'Ruhnu',
            },
        },
        'EE-714': {
            numericCode: '233',
            code: 'EE-714',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-74',
            names: {
                et: 'Saaremaa',
            },
        },
        'EE-79': {
            numericCode: '233',
            code: 'EE-79',
            category: {
                id: '407',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    et: {
                        singular: 'maakond',
                        plural: '',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                et: 'Tartumaa',
            },
        },
        'EE-793': {
            numericCode: '233',
            code: 'EE-793',
            category: {
                id: '483',
                names: {
                    en: {
                        singular: 'urban municipality',
                        plural: 'urban municipalities',
                    },
                    et: {
                        singular: 'linn',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité urbaine',
                        plural: '',
                    },
                },
            },
            parent: 'EE-79',
            names: {
                et: 'Tartu',
            },
        },
        'EE-171': {
            numericCode: '233',
            code: 'EE-171',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-79',
            names: {
                et: 'Elva',
            },
        },
        'EE-283': {
            numericCode: '233',
            code: 'EE-283',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-79',
            names: {
                et: 'Kambja',
            },
        },
        'EE-291': {
            numericCode: '233',
            code: 'EE-291',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-79',
            names: {
                et: 'Kastre',
            },
        },
        'EE-432': {
            numericCode: '233',
            code: 'EE-432',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-79',
            names: {
                et: 'Luunja',
            },
        },
        'EE-528': {
            numericCode: '233',
            code: 'EE-528',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-79',
            names: {
                et: 'Nõo',
            },
        },
        'EE-586': {
            numericCode: '233',
            code: 'EE-586',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-79',
            names: {
                et: 'Peipsiääre',
            },
        },
        'EE-796': {
            numericCode: '233',
            code: 'EE-796',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-79',
            names: {
                et: 'Tartu',
            },
        },
        'EE-81': {
            numericCode: '233',
            code: 'EE-81',
            category: {
                id: '407',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    et: {
                        singular: 'maakond',
                        plural: '',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                et: 'Valgamaa',
            },
        },
        'EE-557': {
            numericCode: '233',
            code: 'EE-557',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-81',
            names: {
                et: 'Otepää',
            },
        },
        'EE-824': {
            numericCode: '233',
            code: 'EE-824',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-81',
            names: {
                et: 'Tõrva',
            },
        },
        'EE-855': {
            numericCode: '233',
            code: 'EE-855',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-81',
            names: {
                et: 'Valga',
            },
        },
        'EE-84': {
            numericCode: '233',
            code: 'EE-84',
            category: {
                id: '407',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    et: {
                        singular: 'maakond',
                        plural: '',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                et: 'Viljandimaa',
            },
        },
        'EE-897': {
            numericCode: '233',
            code: 'EE-897',
            category: {
                id: '483',
                names: {
                    en: {
                        singular: 'urban municipality',
                        plural: 'urban municipalities',
                    },
                    et: {
                        singular: 'linn',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité urbaine',
                        plural: '',
                    },
                },
            },
            parent: 'EE-84',
            names: {
                et: 'Viljandi',
            },
        },
        'EE-480': {
            numericCode: '233',
            code: 'EE-480',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-84',
            names: {
                et: 'Mulgi',
            },
        },
        'EE-615': {
            numericCode: '233',
            code: 'EE-615',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-84',
            names: {
                et: 'Põhja-Sakala',
            },
        },
        'EE-899': {
            numericCode: '233',
            code: 'EE-899',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-84',
            names: {
                et: 'Viljandi',
            },
        },
        'EE-87': {
            numericCode: '233',
            code: 'EE-87',
            category: {
                id: '407',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    et: {
                        singular: 'maakond',
                        plural: '',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                et: 'Võrumaa',
            },
        },
        'EE-919': {
            numericCode: '233',
            code: 'EE-919',
            category: {
                id: '483',
                names: {
                    en: {
                        singular: 'urban municipality',
                        plural: 'urban municipalities',
                    },
                    et: {
                        singular: 'linn',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité urbaine',
                        plural: '',
                    },
                },
            },
            parent: 'EE-87',
            names: {
                et: 'Võru',
            },
        },
        'EE-142': {
            numericCode: '233',
            code: 'EE-142',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-87',
            names: {
                et: 'Antsla',
            },
        },
        'EE-698': {
            numericCode: '233',
            code: 'EE-698',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-87',
            names: {
                et: 'Rõuge',
            },
        },
        'EE-732': {
            numericCode: '233',
            code: 'EE-732',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-87',
            names: {
                et: 'Setomaa',
            },
        },
        'EE-917': {
            numericCode: '233',
            code: 'EE-917',
            category: {
                id: '484',
                names: {
                    en: {
                        singular: 'rural municipality',
                        plural: 'rural municipalities',
                    },
                    et: {
                        singular: 'vald',
                        plural: '',
                    },
                    fr: {
                        singular: 'municipalité rurale',
                        plural: '',
                    },
                },
            },
            parent: 'EE-87',
            names: {
                et: 'Võru',
            },
        },
    },
    cities: [
        {
            name: 'Viljandi',
            subdivision: 'Viljandimaa',
        },
        {
            name: 'Tartu',
            subdivision: 'Tartu',
        },
        {
            name: 'Tallinn',
            subdivision: 'Harjumaa',
        },
        {
            name: 'Sillamäe',
            subdivision: 'Ida-Virumaa',
        },
        {
            name: 'Rakvere',
            subdivision: 'Lääne-Virumaa',
        },
        {
            name: 'Pärnu',
            subdivision: 'Pärnumaa',
        },
        {
            name: 'Narva',
            subdivision: 'Ida-Virumaa',
        },
        {
            name: 'Maardu',
            subdivision: 'Harjumaa',
        },
        {
            name: 'Kohtla-Järve',
            subdivision: 'Ida-Virumaa',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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